/**
 * Parses a string containing key = value pairs separated by semi-colons, ampersands or question marks and returns
 * them as an object
 * @param path
 */
export function getParametersFromString(path: string): { [key: string]: string } {
  const params: { [key: string]: string } = {};
  const entries = path.split(new RegExp('[; | & | ?]'))
    .filter((entry) => entry.includes('='))
    .map(entry => entry.split('='));

  /* istanbul ignore next else */
  if (entries) {
    entries
      .filter((entry) => entry[0] && entry[1])
      .forEach((entry) => params[entry[0]] = entry[1]);
  }

  return params;
}

/**
 * Returns true with a chance determined by the given percentage, e.g. for percentage = 0.5, true will be returned for
 * approximately half of all calls
 * @param percentage percentage ad a decimal
 */
export function getChanceResult(percentage: number): boolean {
  return Math.random() <= percentage;
}
